module.exports = __webpack_public_path__ + "static/media/map.4cce03a2.webp";